<app-cd-accordion>
  <app-cd-accordion-panel title="AML Risk Summary">
    @if (isLoading) {
    <app-loading [overlay]="true"></app-loading>
    }

    <!-- AML Risk Summary Data Section -->
    @if (amlRiskSummary && hasAMLData()) {
    <div class="row l-pt-4">
      <!-- AML Risk Summary Data - Header Row -->
      <div class="col-xs-12">
        <div class="aml-grid-header">
          <div class="aml-header-cell"></div>
          <div class="aml-header-cell">AML Type</div>
          <div class="aml-header-cell">Effective Date</div>
          <div class="aml-header-cell">End Date</div>
          <div class="aml-header-cell">AML Type Description</div>
        </div>
      </div>
      <!-- AML Type 1 -->
      @if (amlRiskSummary.amlTyp1) {
      <div class="col-xs-12">
        <div class="aml-grid-row">
          <div class="aml-label-cell">AML Type 1</div>
          <div class="aml-data-cell">{{ amlRiskSummary.amlTyp1 }}</div>
          <div class="aml-data-cell">{{ amlRiskSummary.effDateAmlTyp1 | ssmsDate }}</div>
          <div class="aml-data-cell">{{ amlRiskSummary.endDateAmlTyp1 | ssmsDate }}</div>
          <div class="aml-data-cell">{{ amlRiskSummary.amlTypDesc1 }}</div>
        </div>
      </div>
      }
      <!-- AML Type 2 -->
      @if (amlRiskSummary.amlTyp2) {
      <div class="col-xs-12">
        <div class="aml-grid-row">
          <div class="aml-label-cell">AML Type 2</div>
          <div class="aml-data-cell">{{ amlRiskSummary.amlTyp2 }}</div>
          <div class="aml-data-cell">{{ amlRiskSummary.effDateAmlTyp2 | ssmsDate }}</div>
          <div class="aml-data-cell">{{ amlRiskSummary.endDateAmlTyp2 | ssmsDate }}</div>
          <div class="aml-data-cell">{{ amlRiskSummary.amlTypDesc2 }}</div>
        </div>
      </div>
      }
      <!-- AML Type 3 -->
      @if (amlRiskSummary.amlTyp3) {
      <div class="col-xs-12">
        <div class="aml-grid-row">
          <div class="aml-label-cell">AML Type 3</div>
          <div class="aml-data-cell">{{ amlRiskSummary.amlTyp3 }}</div>
          <div class="aml-data-cell">{{ amlRiskSummary.effDateAmlTyp3 | ssmsDate }}</div>
          <div class="aml-data-cell">{{ amlRiskSummary.endDateAmlTyp3 | ssmsDate }}</div>
          <div class="aml-data-cell">{{ amlRiskSummary.amlTypDesc3 }}</div>
        </div>
      </div>
      }
      <!-- Additional Info Rows -->
      <div class="col-xs-12">
        <div class="aml-info-row">
          <div class="aml-info-label">Overall AML Risk Level</div>
          <div class="aml-info-value">{{ amlRiskSummary.amlRskLvl }}</div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="aml-info-row">
          <div class="aml-info-label">US Indicia Indicator Flag</div>
          <div class="aml-info-value">{{ amlRiskSummary.usIndiciaFlg }}</div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="aml-info-row">
          <div class="aml-info-label">Last Update Date</div>
          <div class="aml-info-value">{{ amlRiskSummary.lastUpdateDate | ssmsDate }}</div>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="aml-info-row">
          <div class="aml-info-label">Last Updated By</div>
          <div class="aml-info-value">{{ amlRiskSummary.lastUpdateBy }}</div>
        </div>
      </div>
    </div>
    }

    <div class="l-flex-col">
      <!-- No Data Message - 没有AML数据时显示 -->
      @if (!isLoading && !hasAMLData()) {
      <div class="row l-pt-4">
        <div class="col-xs-12">
          <span class="cds-body2">No AML Risk Summary data available</span>
        </div>
      </div>
      }

      <!-- Comments Section - Always visible -->
      @if (!isLoading) {
      <div class="row">
        <div class="col-xs-12" [ngClass]="{ 'l-mt-6': amlRiskSummary, 'l-mt-4': !amlRiskSummary }">
          <div class="row middle-xs l-mb-3 l-plr-0">
            <div class="cds-color-green l-mr-8">
              <span class="cds-h6-demibold">Comments</span>
            </div>
            <app-permission
              [role]="PermissionAccess.W"
              [permission]="entityType === 'EE' ? PermissionItem.CUSTOMER_EMPLOYEE : PermissionItem.CUSTOMER_EMPLOYER">
              @if (!commentsShow) {
              <div (click)="editTrigger()" class="row l-plr-0 middle-xs pointer">
                <cds-icon class="l-mr-2" width="20px" height="20px" icon="action:edit"></cds-icon>
                <div class="icon-margin">
                  <span class="cds-h6-demibold">Edit</span>
                </div>
              </div>
              }
            </app-permission>
            @if (commentsShow) {
            <div (click)="editTrigger()" class="row l-plr-0 l-mr-4 middle-xs pointer l-mr-8">
              <cds-icon class="l-mr-2" width="20px" height="20px" icon="action:edit"></cds-icon>
              <div class="icon-margin">
                <span class="cds-h6-demibold">Cancel Editing</span>
              </div>
            </div>
            } @if (!commentsShow) {
            <div class="l-mr-8"></div>
            } @if (!commentsShow) {
            <div (click)="showCommentsLog()" class="row l-mr-4 middle-xs pointer">
              <cds-icon class="l-mr-2" width="20px" height="20px" icon="form:form_search"></cds-icon>
              <div class="icon-margin">
                <span class="cds-h6-demibold">View edit log history</span>
              </div>
            </div>
            }
          </div>
          <div class="">
            <div class="p-line"></div>
          </div>
          <!-- Edit Mode -->
          @if (commentsShow) {
          <div class="area-width l-pt-2 l-pb-2 l-plr-0">
            <app-cd-textarea label="Edit Comment" [value]="commentsData" (valueChange)="commentInput($event)" [maxlength]="1000" [height]="'78px'">
            </app-cd-textarea>
            <div class="row l-pt-4 l-plr-0">
              <cds-button (click)="reset()" [config]="resetConfig" label="{{ 'create.botton.reset' | lang }}" class="l-mr-8"></cds-button>
              <cds-button (click)="confirm()" [config]="confirmConfig" label="{{ 'create.botton.submit' | lang }}"></cds-button>
            </div>
          </div>
          }
          <!-- Display Mode -->
          @if (!commentsShow && amlComment.comment) {
          <div class="l-pb-5">
            <div class="l-mb-5 cds-color-navy-light4">
              Latest update: <span>{{ updateDateGen(amlComment.updatedAt) }}</span
              >, by <span>{{ amlComment.updatedBy }}</span>
            </div>
            <div class="comment-display">
              <span class="cds-body">{{ amlComment.comment }}</span>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </app-cd-accordion-panel>
</app-cd-accordion>
